<template>
<div>
    <div style="display: inline-block; width: 50%; vertical-align: middle;">
        <span v-if="tableData.length !== 0" style="display: inline-block; line-height: 40px; text-align: left;">附件数量：{{tableData.length}}</span>
    </div>
    <el-row style="margin-bottom: 0; display: inline-block; width: 50%; vertical-align: middle;" v-if="viewFlag === 'edit'">
        <el-col>
            <el-upload action :http-request="upload" :data="param" :disabled="!bizId" :show-file-list="false" style="text-align: right" multiple>
                <el-button slot="trigger" size="small" class="mb15" type="primary" plain :disabled="!bizId">点击上传</el-button>
                <!--          <span class="el-upload__tip" >上传文件不能超过500kb</span>-->
            </el-upload>
        </el-col>
    </el-row>
    <el-table :data="tableData" :header-cell-style="{background:'#f5f5f5'}" border style="width: 100%; margin-bottom:15px" size="mini">
        <el-table-column prop="originalName" header-align="center" align="left" label="文件名称">
        </el-table-column>

        <!-- <el-table-column
        prop="fileDesc"
        header-align="center"
        align="left"
        label="文件描述">
      </el-table-column> -->

        <el-table-column prop="fileSize" header-align="center" align="right" label="文件大小">
        </el-table-column>

      <el-table-column v-if="uploadDate" prop="createTime" header-align="center" align="right" label="上传时间">
      </el-table-column>

        <el-table-column v-if="viewFlag === 'view'" prop="fileDir" header-align="center" align="center" width="200" label="查看附件">
            <template slot-scope="scope">
                <el-button v-if="scope.row.fileType === 'application/pdf'" icon="el-icon-view" type="text" @click="viewHandle(scope.row)">查看</el-button>
                <el-button icon="el-icon-view" type="text" @click="downloadHandle(scope.row)">下载</el-button>
            </template>
        </el-table-column>

        <el-table-column v-else prop="fileDir" header-align="center" align="center" width="220" label="查看附件">
            <template slot-scope="scope">
                <el-button :disabled="scope.row.fileType !== 'application/pdf'" icon="el-icon-view" type="text" @click="viewHandle(scope.row)">查看</el-button>
                <el-button icon="el-icon-view" type="text" @click="downloadHandle(scope.row)">下载</el-button>
                <el-button type="text" v-if="canDelete" @click="deleteFile(scope.row)">删除</el-button>
            </template>
        </el-table-column>

    </el-table>

    <pdf-view v-if="pdfPreviewVisible" ref="pdfPreview"></pdf-view>
</div>
</template>

<script>
import {
    getFileList,
    uploadFile,
    getUrl,
    deleteFileById,
    getChangeFileList,
    downLoad
} from '@/controller/sys'
import {
    FILE_BIZ_TYPE,
    getLabelByValue
} from '@/utils/const'
import PdfView from '@/components/pdf-view'
export default {
    props: {
        bizId: Number,
        bizType: Number,
        fileSubType: Number,
        canDelete: {
          type: Boolean,
          default: true
        },
        uploadDate: {
          type: Boolean,
          default: false
        }
    },
    data() {
        return {
            pdfPreviewVisible: false,
            visible: false,
            otherParams: {}, //保留参数
            tableData: [],
            filelist: [],
            viewFlag: '',
            param: {
                bizId: '',
                bizType: '',
                fileSubType: '',
            },
        }
    },

    components: {
        PdfView
    },
    mounted() {
        this.init();
    },
    methods: {
        init(viewFlag) {
            this.tableData = [];
            this.param.bizId = this.bizId;
            this.param.bizType = this.bizType;
            this.param.fileSubType = this.fileSubType;
            this.param.otherParams = this.otherParams;
            this.viewFlag = viewFlag
            this.$nextTick(() => {
                if (this.bizId && this.bizType) {
                    if (this.fileSubType) {
                        getChangeFileList({
                            'id': this.bizId,
                            'bizType': this.bizType,
                            'fileSubType': this.fileSubType
                        }).then(data => {
                            if (data && data.code === '00') {
                                this.tableData = data.body
                            } else {
                                this.tableData = []
                            }

                        })
                    } else {
                        getFileList({
                            'id': this.bizId,
                            'bizType': this.bizType
                        }).then(data => {
                            if (data && data.code === '00') {
                                this.tableData = data.body
                            } else {
                                this.tableData = []
                            }

                        })
                    }
                }
            })
        },
        upload(obj) {
            // this.param.bizId = this.bizId;
            this.param.bizId = this.param.bizId ? this.param.bizId : this.bizId
            this.param.bizType = this.bizType;
            this.param.fileSubType = this.fileSubType;
            this.param.otherParams = this.otherParams;
            if (!this.param.fileSubType) {
                this.param.fileSubType = 0
            }
            let formData = new FormData()
            formData.set('file', obj.file)
            formData.set('fileName', '文件名称')
            formData.set('id', this.param.bizId)
            formData.set('bizType', this.param.bizType)
            formData.set('fileSubType', this.param.fileSubType)
            let fileDir = getLabelByValue(FILE_BIZ_TYPE, this.param.bizType);
            if (fileDir) {
                formData.set('fileDir', fileDir)
            } else {
                this.$message.error("请先配置附件的业务类型！");
                return;
            }

            // 先储存
            //this.files.push(formData)
            console.log("文件上传参数id", this.param.bizId)
            uploadFile(formData).then(data => {
                if (data.code === '00') {
                    this.selectFileList();
                    this.$message.success({
                        message: '上传成功！',
                        type: 'success',
                        duration: 1500,
                    });
                }
            })
        },
        downloadHandle(row) {
            console.log(row, 'row')
            downLoad({
                'id': row.id
            }).then(data => {
                if (data && data.code === '00' && data.body) {
                  const blob = new Blob([data.body]);
                  if (data.body instanceof Blob) {
                    // 如果直接返回的是 Blob
                    this.saveAs(data.body, row.originalName);
                  } else if (typeof data.body === 'string') {
                    // 如果返回的是 base64 字符串
                    try {
                      // 使用更高效的Base64转Blob方法
                      const binaryString = atob(data.body);
                      const bytes = new Uint8Array(binaryString.length);
                      for (let i = 0; i < binaryString.length; i++) {
                        bytes[i] = binaryString.charCodeAt(i);
                      }
                      const blob = new Blob([bytes], { type: row.fileType || 'application/pdf' });
                      this.saveAs(blob, row.originalName);
                    } catch (error) {
                      console.error('Base64转换错误:', error);
                      this.$message.error("文件下载失败");
                    }
                  } else {
                    // 如果是 arraybuffer 或其他格式
                    const blob = new Blob([data.body], { type: row.fileType || 'application/pdf' });
                    this.saveAs(blob, row.originalName);
                  }
                } else {
                    this.tableData = []
                }
            })
        },
      viewHandle(row) {
        console.log(row, 'row')
        downLoad({
          'id': row.id
        }).then(data => {
          if (data && data.code === '00' && data.body) {
            let blob;
            if (data.body instanceof Blob) {
              // 如果直接返回的是 Blob
              blob = data.body;
            } else if (typeof data.body === 'string') {
              // 如果返回的是 base64 字符串
              const byteString = atob(data.body);
              const ab = new ArrayBuffer(byteString.length);
              const ia = new Uint8Array(ab);
              for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
              }
              blob = new Blob([ab], { type: row.fileType || 'application/octet-stream' });
            } else {
              // 如果是 arraybuffer 或其他格式
              blob = new Blob([data.body], { type: row.fileType || 'application/octet-stream' });
            }

            // 创建临时 URL 进行预览
            const url = window.URL.createObjectURL(blob);

            if (row.fileType === 'application/pdf') {
              // PDF 文件使用内置预览组件
              this.previewPdf(url);
            } else {
              // 其他文件类型直接在新窗口打开预览
              window.open(url, '_blank');
            }

            // 清理临时 URL
            setTimeout(() => {
              window.URL.revokeObjectURL(url);
            }, 1000);
          } else {
            this.tableData = [];
          }
        });
      },


        deleteFile(row) {

            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                deleteFileById({
                    'fileId': row.id
                }).then(data => {
                    if (data.code === '00') {
                        this.selectFileList();
                        this.$message.success({
                            message: '删除成功！',
                            type: 'success',
                            duration: 1500,
                        });
                    }
                }).catch(() => {

                })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
                this.viewData.visible = false;
            });

        },

        selectFileList() {
             if (this.param.bizId && this.param.bizType) {
                if (this.param.fileSubType) {
                    getChangeFileList({
                        'id': this.param.bizId,
                        'bizType': this.param.bizType,
                        'fileSubType': this.param.fileSubType
                    }).then(data => {
                        if (data && data.code === '00') {
                            this.tableData = data.body
                        } else {
                            this.tableData = []
                        }

                    })
                } else {
                    getFileList({
                        'id': this.param.bizId,
                        'bizType': this.param.bizType
                    }).then(data => {
                        if (data && data.code === '00') {
                            this.tableData = data.body
                        } else {
                            this.tableData = []
                        }

                    })
                }
            }
        },
        getBlob(url, cb) {
            var xhr = new XMLHttpRequest();
            console.log("1111111111111111111111111======================")
            console.log(url,'url')
            xhr.open("GET", url, true);
            xhr.responseType = "blob";
            xhr.onload = function () {
                if (xhr.status === 200) {
                    cb(xhr.response);
                }
            };
            xhr.send();
        },
        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename);
            } else {
                var link = document.createElement("a");
                var body = document.querySelector("body");

                link.href = window.URL.createObjectURL(blob);
                link.download = filename;

                // fix Firefox
                link.style.display = "none";
                body.appendChild(link);

                link.click();
                body.removeChild(link);

                window.URL.revokeObjectURL(link.href);
            }
        },
        download(url, filename) {
            const _this = this
            console.log(url,'url')
            this.getBlob(url, function (blob) {
                _this.saveAs(blob, filename);
            });
        },

        previewPdf(pdfUrl) {
            console.log(pdfUrl,'pdfUrl');
            this.pdfPreviewVisible = true
            this.$nextTick(() => {
                //此处参数传入pdf文件的地址
                this.$refs.pdfPreview.init(pdfUrl)
            })
        },
      getFileList() {
        this.selectFileList();
        return this.tableData;
      }
    },

}
</script>

<style lang="scss">
.el-dialog__body {
    .user-info-dialog-form {
        width: 95%;

        .el-select {
            width: 222px;
        }
    }
}

.el-upload__tip {
    color: red;
    margin-left: 10px;
}

.el-row {
    margin-bottom: 10px;

    &:last-child {
        margin-bottom: 0;
    }
}

.mb15 {
    margin-bottom: 15px;
}
</style>
